<template>
  <div class="m-overlay active" v-if="active">
    <div class="m-vcenter">
      <div class="m-hcenter">
        <div class="m-content" v-click-outside="()=>{ this.$emit('modalClosed') }">
          <slot></slot>
          <div class="m-close" @click="$emit('modalClosed')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Modal',
  props:{
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active: {
      immediate: true,
      handler: (active)=>{
        if(active) document.body.classList.add('no-overflow');
        else document.body.classList.remove('no-overflow');
      }
    }
  }
};
</script>

<style>
.m-overlay{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  overflow: auto;
  padding-top: 5%;
  background: rgba(51, 51, 51, 0);
  text-align: center;
}
.m-overlay.active{
  display: block;
}
.m-vcenter{
  display: table;
  margin: auto;
  height: 100%;
  padding: 0 5%;
}
.m-hcenter{
  display: table-cell;
  vertical-align: middle;
  overflow: auto;
}
.m-content{
  position: relative;
  margin-bottom: 5%;
  background: #fff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  text-align: left;
}
.m-close{
  position: absolute;
  right: 2px;
  top: 2px;
  cursor: pointer;
}
.m-close:before{
  content: '×';
  display: block;
  line-height: 15px;
  font-size: 20px;
}
.no-overflow{
  overflow: hidden;
}
</style>